import { render } from "./humanityCourseInfo.vue?vue&type=template&id=4dd7d916&scoped=true"
import script from "./humanityCourseInfo.vue?vue&type=script&lang=js"
export * from "./humanityCourseInfo.vue?vue&type=script&lang=js"

import "./humanityCourseInfo.vue?vue&type=style&index=0&id=4dd7d916&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd7d916"]])

export default __exports__